import { useEffect, useState } from 'react';

const useTopNavigationReady = (enabled) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    let observer;

    const checkNavigation = () => {
      const navigation = document.querySelector(
        'arm-top-navigation'
      );

      if (!navigation) {
        return false;
      }

      setReady(true);
      observer?.disconnect();

      return true;
    };

    if (checkNavigation()) {
      return;
    }

    observer = new MutationObserver(checkNavigation);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [enabled]);

  return ready;
};

export default useTopNavigationReady;
